import { render, staticRenderFns } from "./UpdateAgencyNameForm.vue?vue&type=template&id=90073b4c"
import script from "./UpdateAgencyNameForm.vue?vue&type=script&lang=ts"
export * from "./UpdateAgencyNameForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports